import api from "./axiosInstance";

// GET /overview/getAllPagesData?start=ISO&end=ISO&limit=25&offset=0
export async function getAllPagesData(params) {
	const { start, end, limit = 25, offset = 0 } = params || {};
	const { data } = await api.get("/overview/getAllPagesData", {
		params: { start, end, limit, offset }
	});
	return data;
}

// GET /overview/generalSummary?check_mfa=true
export async function getOverviewGeneralSummary(params) {
	const { checkMfa = true } = params || {};
	const { data } = await api.get("/overview/generalSummary", {
		params: { check_mfa: checkMfa }
	});
	return data;
}

export async function getFrequentlyAsked(start, end, limit = 10) {
	const params = {};
	if (start) params.start = start;
	if (end) params.end = end;
	if (limit) params.limit = limit;
	const { data } = await api.get("/overview/frequentlyAsked", { params });
	return data;
}

export async function getSuggestions(limit = 10) {
	const params = {};
	if (limit) params.limit = limit;
	const { data } = await api.get("/overview/suggestions", { params });
	return data;
}

export async function getUnansweredQuestions(start, end, limit = 10) {
	const params = {};
	if (start) params.start = start;
	if (end) params.end = end;
	if (limit) params.limit = limit;
	const { data } = await api.get("/overview/unansweredQuestions", { params });
	return data;
}

export async function getRecentDocuments(start, end, limit = 5) {
	const params = {};
	if (start) params.start = start;
	if (end) params.end = end;
	if (limit) params.limit = limit;
	const { data } = await api.get("/dashboard/recentDocuments", { params });
	return data;
}


// POST /overview/search
export async function postOverviewSearch(payload) {
	const body = typeof payload === "string" ? { query: payload } : (payload || {});
	const { data } = await api.post("/overview/search", body);
	return data;
}


